import { makeStyles } from '@material-ui/styles';

export const useAppSelectStyles = makeStyles(() => ({
  formControl: {
    width: '100%',
    display: (props) => (props.hidden ? 'none' : ''),
  },
  errorText: {
    color: '#FF0000',
    textAlign: 'center',
  },
}));
